module.exports = __webpack_public_path__ + "media/images/icons/head-icon-e2319ec6aaf52ce36690491ac93210f2.svg";